import { Field, FieldProps } from "react-final-form";
import * as React from "react";
import { FormField, Required } from "../../../../index";

interface ConditionalFieldItemProps {
  field: FormField;
  values: any;
}

const prepareComponentProps = (
  field: FormField,
  props: ConditionalFieldItemProps
) => {
  return {
    values: props.values,
    key: field.name,
    name: field.name,
    component: field.type.Component,
    validate: field.type.valid,
    disabled: field.readonly,
    readOnly: field.readonly,
    ...field.type.props
  } as FieldProps<any, any>;
};

export const ConditionalFieldItem = (props: ConditionalFieldItemProps) => {
  const { field } = props;

  const requiredSuffix =
    field.type.validators.indexOf(Required) > -1 ? " *" : "";
  const label = (field.title || field.name) + requiredSuffix;

  return (
    <>
      <label
        style={{
          fontWeight: "bold",
          textAlign: "left",
          alignSelf: "center"
        }}
      >
        {label}
      </label>
      <Field {...prepareComponentProps(field, props)} />
    </>
  );
};
